<template>
  <div>
    <div class="modal modal--welcomeback modal--zero-balance " id="resubscribe_with_pin">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close" @click="$emit('close')"></i></button>
        <div class="modal__header">
        </div>
        <div class="modal__body">
          <h1>{{ getTranslations.home_modals_resubscribe_game_sms_do_you }}</h1>
          <img class="modal_icon_main" src="static/images/resub-prize.png" alt="">
          <p>{{ getTranslations.home_modals_resubscribe_game_sms_in_order_to }}</p>
        </div>
        <div class="modal__footer"><span class="terms">
        {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'home_modals_resubscribe_game_sms_resubscribe_now_by_sending') }}
          {{ getTranslations.home_modals_resubscribe_game_sms_resubscribe_with }}
          {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_resub_resubscribe_gamesms_modal_start') }}
          {{ getTranslations.home_modals_resubscribe_game_sms_resubscribe_to }}
          {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_resub_resubscribe_gamesms_modal_yyyy') }}
      </span>
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  // modal_resubscribe_sms.html.html
  name: 'resubscribe-game-sms',
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/ResubscribeGameSms.vue